import {
  Button,
  Col,
  Divider,
  Form,
  Row,
  Spin,
  Typography,
  notification,
} from "antd";
import { InputFields } from "components/common";
import React, { useEffect, useMemo, useRef, useState } from "react";
import "./HealthInsuranceInfo.scss";
import { bhytInfo2Fields, bhytInfo3Fields, bhytInfoFields } from "./config";
import { insuranceService } from "api";
import dayjs from "dayjs";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { RECEIVE_ACTION_TYPE } from "types/enums/receive-action-type";
import { Buffer } from "buffer";
import _ from "lodash";
import Notification from "components/common/notification/notification";
import { toDateTime } from "helper/format-date";
import InformModal from "./InformModal/InformModal";
import { setAction } from "redux/reducer/receive";
import { FORMAT_TIME } from "types/enums";
import {
  convertIosStringToDate,
  convertIosStringToDateDayjs,
  formatDateOrStringToStringGMT_7,
} from "helper/common";

const HealthInsuranceInfo = (props) => {
  const action = useAppSelector((state) => state.receive);
  const { form } = props;
  const [disableInsuranceCheck, setDisableInsuranceCheck] =
    useState<boolean>(false);
  const [idLanKham, setIdLanKham] = useState<number>(null);
  const [checkOK, setCheckOK] = useState<boolean>(false);
  const dispatch = useAppDispatch();
  const informRef = useRef<any>();
  const onCheckInsurance = async () => {
    const fValues = form.getFieldsValue();
    if (!fValues.maTheBhyt) {
      Notification("error", "Chưa nhập mã thẻ");
      return;
    }
    if (!fValues.hoTenTrenThe) {
      Notification("error", "Chưa nhập họ tên trên thẻ");
      return;
    }
    if (!fValues.ngaySinhTrenThe) {
      Notification("error", "Chưa nhập ngày sinh trên thẻ");
      return;
    }
    try {
      const res = await insuranceService.checkInsurance({
        mathe: fValues.maTheBhyt,
        hoten: fValues.hoTenTrenThe,
        namsinh: fValues.ngaySinhTrenThe.year(),
      });
      if (res.status == 200) {
        informRef.current?.setData({ ...res.data });
        informRef.current?.openModal();
      }
      if (res.status == 404) {
        Notification("error", "Không tìm thấy thông tin");
      }
    } catch (err) {
      if (err.response.status == 400) {
        Notification("error", "Không tìm thấy thông tin");
      } else {
        notification.error({
          message: "Lỗi xảy ra khi lấy thông tin bảo hiểm y tế",
        });
      }
    }
  };
  const onClose = async () => {
    form.resetFields();
  };
  const onSave = async (data) => {
    if (["000", "001", "002", "130", "004"].includes(data.maLoi)) {
      form.setFieldsValue({
        maTheBhyt: data.maThe,
        hoTenTrenThe: data.hoTen,
        phanTramMienGiam: data.phanTramMienGiam,
        ngaySinhTrenThe: data?.ngaySinh ? dayjs(data?.ngaySinh) : null,
        diaChiTrenThe: data.diaChi,
        noiDkkcbd: `${data.maNoiDKKCBBD} - ${data.noiDKKCB}`,
        the5Nam: toDateTime(data.ngayDu5Nam, "DD/MM/YYYY"),
        ngayBatDau: toDateTime(data.gioiHanTheTu, "DD/MM/YYYY"),
        ngayKetThuc: toDateTime(data.gioiHanTheDen, "DD/MM/YYYY"),
        ngayCapNhat: toDateTime(data.ngayCapNhat, "DD/MM/YYYY"),
        thoiGianNhapVienNoiTru: toDateTime(
          data.ngayCapNhat,
          "HH:mm DD/MM/YYYY"
        ),
        lyDoVaoVien: data.maNoiDKKCB === 33702 ? 1 : 4,
      });
      setCheckOK(true);
    } else {
      // form.resetFields();
      form.setFieldsValue({
        maTheBhyt: null,
        hoTenTrenThe: null,
        ngaySinhTrenThe: null,
        phanTramMienGiam: null,
        noiDkkcbd: null,
        the5Nam: null,
        lyDoVaoVien: null,
        diaChiTrenThe: null,
        maKhuVuc: null,
        donVi: null,
        chucVu: null,
        thoiGianTraThe: null,
        ngayBatDau: null,
        ngayKetThuc: null,
        nguoiCapNhatThe: null,
        ngayCapNhatThe: null,
      });
    }
  };
  const onBack = async () => {
    form.setFieldValue("thoiGianTraThe", dayjs());
  };
  const transformCode = (v, namePath) => {
    form.setFieldValue(namePath, String(v).toUpperCase());
  };
  // const onFinish = async values => {
  //   if (!idLanKham && !props.form.getFieldValue("id")) {
  //     Notification("error", "Hãy nhập thông tin phiếu khám!");
  //     return;
  //   }
  //   form
  //     .validateFields()
  //     .then(async values => {
  //       let data = {
  //         ...values,
  //         idLanKham: idLanKham ? idLanKham : props.form.getFieldValue("id"),
  //         idLoaiBaoHiem: 0,
  //         maTheBaoHiemYTe: values.maTheBhyt,
  //         diaChi: values.diaChiTrenThe,
  //         ngaySinh: values.ngaySinhTrenThe.format("DD/MM/YYYY"),
  //         noiDangKyKhamChuaBenh: values.noiDkkcbd,
  //         ngayDu5Nam: values.the5Nam
  //           ? values.the5Nam.format("DD/MM/YYYY")
  //           : null,
  //         tenTrenThe: values.hoTenTrenThe,
  //         hieuLucTu: values.ngayBatDau.format("DD/MM/YYYY"),
  //         hieuLucDen: values.ngayKetThuc.format("DD/MM/YYYY"),
  //       };
  //       let res = await insuranceService.postInsuranceInfo(data);
  //       // if (res.status == 200) {
  //       //   setInsuranceData({
  //       //     ...values,
  //       //     ngaySinhTrenThe: values.ngaySinhTrenThe
  //       //       ? values.ngaySinhTrenThe.toISOString()
  //       //       : null,
  //       //     the5Nam: values.the5Nam ? values.the5Nam.toISOString() : null,
  //       //     ngayBatDau: values.ngayBatDau
  //       //       ? values.ngayBatDau.toISOString()
  //       //       : null,
  //       //     ngayKetThuc: values.ngayKetThuc
  //       //       ? values.ngayKetThuc.toISOString()
  //       //       : null,
  //       //     ngayCapNhatThe: values.ngayCapNhatThe
  //       //       ? values.ngayCapNhatThe.toISOString()
  //       //       : null,
  //       //     coTheBhyt: true,
  //       //   });
  //       // }
  //     })
  //     .catch(err => {
  //       Notification("error", "Lỗi khi thêm thẻ bảo hiểm y tế");
  //     });
  // };
  // const [enableAdd, setEnableAdd] = useState<boolean>(false);

  useEffect(() => {
    if (action.actionType === RECEIVE_ACTION_TYPE.EDITPHIEUKHAM) {
      setIdLanKham(action.dataPassing.id);
    }
    if (action.actionType === RECEIVE_ACTION_TYPE.HUYKHAM) {
      form.resetFields();
    }
    if (action.actionType === RECEIVE_ACTION_TYPE.PHIEUKHAMMOI) {
      form.setFieldsValue({
        maTheBhyt: null,
        hoTenTrenThe: null,
        ngaySinhTrenThe: null,
        phanTramMienGiam: null,
        noiDkkcbd: null,
        the5Nam: null,
        lyDoVaoVien: null,
        diaChiTrenThe: null,
        maKhuVuc: null,
        donVi: null,
        chucVu: null,
        thoiGianTraThe: null,
        ngayBatDau: null,
        ngayKetThuc: null,
        nguoiCapNhatThe: null,
        ngayCapNhatThe: null,
      });
    }
  }, [action]);

  const [infData, setInfData] = useState({});

  const [loading, setLoading] = useState(false);

  useMemo(() => {
    form.setFieldsValue(infData);
    setLoading(false);
  }, [infData]);

  const handleChange = (e) => {
    // setLoading(true);
    setTimeout(() => {
      setLoading(true);
      decodedText(e.target.value);
    }, 1000);
  };

  const decodedText = async (data) => {
    const splitData = data.split("|");

    const userName = splitData[1];
    const noiDkkcbd = splitData[4];
    if (userName && noiDkkcbd) {
      // Chuyển đổi từ mã hóa hexa sang dạng dữ liệu nhị phân (binary data)
      const decodedUserName = await Buffer.from(userName, "hex");
      const decodeNoiDkkcbd = await Buffer.from(noiDkkcbd, "hex");
      // Chuyển dữ liệu nhị phân sang chuỗi văn bản (đây chỉ là một ví dụ, tùy thuộc vào nội dung của dữ liệu, nó có thể không hiển thị đúng)
      const decodedText = await decodedUserName.toString("utf8");
      const decodeTextNoiDkkcbd = await decodeNoiDkkcbd.toString("utf8");

      await setInfData({
        ...infData,
        maTheBhyt: splitData[0],
        hoTenTrenThe: decodedText,
        ngaySinhTrenThe: dayjs(splitData[2], "DD/MM/YYYY"),
        noiDkkcbd: decodeTextNoiDkkcbd,
      });
    } else {
      setLoading(false);
    }
  };

  return (
    <Row className="bhyt-info-container">
      <Row justify={"start"}>
        <Typography.Text strong>Thông tin thẻ BHYT</Typography.Text>
      </Row>
      <Divider type="horizontal" />
      <Row>
        <Form labelAlign="left" form={form}>
          <Spin spinning={loading}>
            <Row gutter={[4, 8]}>
              <InputFields data={bhytInfoFields(handleChange)} />
              <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                <Row style={{ gap: "4px" }}>
                  <Button
                    className="btn-sub"
                    type="ghost"
                    onClick={onCheckInsurance}
                    disabled={disableInsuranceCheck}
                  >
                    Kiểm tra thẻ
                  </Button>
                </Row>
              </Col>
              <InputFields data={bhytInfo2Fields} />

              <InputFields data={bhytInfo3Fields} />
            </Row>
          </Spin>
        </Form>
        <InformModal ref={informRef} onSave={onSave} onClose={onClose} />
      </Row>
    </Row>
  );
};

export default HealthInsuranceInfo;
